import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import PortableText from '@sanity/block-content-to-react'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const Credits = styled.div`
  font-size:var(--medium-text);
  display:grid;
  grid-gap:2rem;
  margin-top:20vh;
  grid-template-columns:repeat(2,1fr);

  ${media.medium}{
  grid-template-columns:repeat(3,1fr);

  }


  p{
    font-weight:200;
  }
  h2{
    font-weight:500;
    font-family:var(--sans);
    font-size:var(--small-text);
    text-transform:uppercase;
    letter-spacing:0.04em;
    margin-top:4em;
  }
`

const VisitingArtists = styled.div`

`

const VisitingCurators = styled.div`

`

export default function SiteCredits ({ data }) {
  return (
    <Credits className="credits">

      <VisitingArtists>
        <h2>Visiting Artists</h2>
        <PortableText blocks={data._rawVisitingArtists} />

        <h2>Workshops</h2>
        <PortableText blocks={data._rawWorkshops} />
      </VisitingArtists>

      <VisitingCurators>
        <h2>Visiting Curators</h2>
        <PortableText blocks={data._rawVisitingCurators} />
      </VisitingCurators>

    </Credits>
  )
}
